export const WEB_QR_CODE_CAMPAIGN = 'PRODUCT_WEB_GLOBAL_ACQ_ALLP_ALL_qr_code';

export type AppDownloadPlacementEntry = {
  campaign: string;
  feature: string;
  stage: string;
  appPath?: string;
  fallback?: string;
};

export const APP_DOWNLOAD_PLACEMENTS = {
  footer: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'footer',
    stage: 'footer qr',
  },
  signup_modal: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'signup_modal',
    stage: 'signup modal qr',
  },
  blog_article: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'blog',
    stage: 'article footer qr',
  },
  purchase_confirmation: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'checkout_success',
    stage: 'purchase confirmation qr',
  },
  burger_menu: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'navigation',
    stage: 'burger menu qr',
  },
  outfits_upsell: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'home_upsell',
    stage: 'outfits upsell qr',
  },
  app_upsell_modal: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'app_upsell',
    stage: 'app upsell modal qr',
  },
  saved_search_modal: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'saved_search',
    stage: 'saved search modal qr',
  },
  make_offer: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'make_offer',
    stage: 'offer sent qr',
  },
  sellerhub_payments: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'seller_hub',
    stage: 'payments modal qr',
    appPath: '/payments',
    fallback: 'https://depop.app.link/payments/',
  },
  guest_likes_card: {
    campaign: WEB_QR_CODE_CAMPAIGN,
    feature: 'guest_likes',
    stage: 'view guest likes qr',
  },
} as const satisfies Record<string, AppDownloadPlacementEntry>;

export type AppDownloadPlacement = keyof typeof APP_DOWNLOAD_PLACEMENTS;
